import { Burger } from '../core'

export default {
  burger: undefined,

  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.burger', {
      onToggle: function() {
        var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
        if (scrollTop != 0) {
          obj.top = scrollTop
        }
        $('body').css('--top',-scrollTop + 'px');
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open --no-scroll')
        } else {
          $('body').removeClass('--menu-open --no-scroll')
        }
        window.scrollTo({ top: obj.top});
      },
    })

    $(window).click(function() {
      if ($('body').hasClass('--menu-open')) {
        $('body').removeClass('--menu-open --no-scroll')
        $('.header__search').removeClass('--search-open')
        $('.header__burger').attr('aria-expanded', 'false');
        window.scrollTo({ top: obj.top});
        $('main .page-section').first().click();
      }
    });

    $('.navigation__wrapper, .header__burger, .header__search, .header__search-btn').click(function(event){
      event.stopPropagation();
    });
  }
}
